function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0284 3.30094L12.699 4.97114L13.2962 4.37431C13.2963 4.37427 13.2963 4.37423 13.2964 4.37419M11.0284 3.30094L11.2726 2.34998C11.6963 1.92632 12.6666 1.84226 13.1744 2.34998L13.6498 2.82542C14.1575 3.33314 14.0741 4.30353 13.6498 4.72786L13.2964 4.37419M11.0284 3.30094L11.6261 2.70365L11.6262 2.70353C11.7249 2.60477 11.9386 2.50834 12.2066 2.50049C12.469 2.49281 12.69 2.57269 12.8208 2.70353L13.2962 3.17897C13.4272 3.3099 13.5071 3.53094 13.4995 3.7934C13.4917 4.0613 13.3954 4.27503 13.2964 4.37419M11.0284 3.30094L13.2964 4.37419M11.041 6.62963L4.83852 12.8322L2.66694 13.333L3.16779 11.1614L9.37022 4.95886L11.041 6.62963Z"
});

function SvgIcHabitEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHabitEdit);
export default ForwardRef;